<template>

	<section>
	
		<div class="upper">
			<slot name="masthead" />
		</div>
		
		<div class="lower">
			<div class="body"><slot name="body" /></div>
		</div>

		<div class="footer">
			<slot name="footer" />
		</div>
	
	</section>

</template>

<script>

	export default {
		name: "layoutB"
	}

</script>

<style lang="scss" scoped>

	@import "media.scss";

	.upper {

	}

	.lower {
		margin-bottom:17.9rem;
	}

	.body {
		width:100%; display:flex; align-items:center; background:#ffffff; position:relative; z-index:1;
		@include media(large) {
			max-width:80vw; margin:-10.6rem auto 0 auto;
		}
		img {
			max-width:100%;
		}
	}

	.footer {
		border-top:1px solid #DEE1E5;
	}

</style>


// WEBPACK FOOTER //
// src/layouts/layoutB/index.vue